import { Row } from "@tanstack/react-table"
import classNames from "classnames"
import { ReactNode, useCallback } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { Referral } from "../../types/Referral"

interface Props<
  T extends { Rendered: JSX.Element | ReactNode; Row: Partial<Referral> },
> {
  row: Row<T>
  index: number
}

export function ReferralTableRow<
  T extends { Rendered: JSX.Element | ReactNode; Row: Partial<Referral> },
>({ row, index }: Props<T>) {
  const navigate = useNavigate()
  const [params] = useSearchParams()

  // use the state from the table to maintain page if it is there
  const navigateToReview = useCallback(() => {
    navigate(`${row.original?.id}`, { state: { page: params.get("page") } })
  }, [navigate, params, row.original?.id])

  return (
    <tr
      key={row.id}
      className="border-t border-t-[color:var(--alias-color-border-base)] cursor-pointer hover:bg-[color:var(--alias-color-bg-alt)]"
      onClick={() => navigateToReview()}
      onKeyDown={(e) => {
        if (e.code === "Enter") {
          navigateToReview()
        }
      }}
      tabIndex={0}
    >
      {row.getVisibleCells().map((cell) => (
        <td
          key={cell.id}
          className={classNames("min-w-[210px]", {
            "w-full": index === 0,
          })}
        >
          <div className="px-5 py-4">{cell.renderCell()}</div>
        </td>
      ))}
    </tr>
  )
}
